import { Sport } from "sbtech-online-sportcontent-sportbook";
import { EntityType } from "sbtech-sports-data-api-contracts";
import { FilterPredicate, SubFilterPredicate } from "../../data";
import { Filters } from "../../typings";
import { FilterFunctions } from "../FilterFunctions";
export class FilterManager {
    constructor() {
        this.filterEntity = (sportIds, from, to, x) => {
            return FilterFunctions[this.getMainFilterFunction()](x, sportIds, from, to) && this.getSubFilterFunction(x);
        };
        this.mainPredicate = FilterPredicate.Sport;
        this.subPredicate = SubFilterPredicate.None;
    }
    getSubFilterFunction(x) {
        if (x && (this.subPredicate === SubFilterPredicate.None || x.entityType !== EntityType.Event && x.entityType.toString() !== Sport.EntityTypeEnum.Event.toString())) {
            return true;
        }
        return FilterFunctions.filterByTag(x, SubFilterPredicate[this.subPredicate]);
    }
    getMainFilterFunction() {
        return Filters[this.mainPredicate].fn;
    }
    setMainPredicate(newPredicate) {
        this.mainPredicate = newPredicate;
    }
    setSubPredicate(newPredicate) {
        this.subPredicate = newPredicate;
    }
    getMainPredicate() {
        return this.mainPredicate;
    }
    getSubPredicate() {
        return this.subPredicate;
    }
    getMainFilterCollections() {
        return Filters[this.mainPredicate].collections;
    }
    isCurrentMainFilter(newFilter) {
        return this.mainPredicate === newFilter;
    }
    isCurrentSubFilter(newFilter) {
        return this.subPredicate === newFilter;
    }
    filterMarketsByType(market, marketTypes) {
        return FilterFunctions.filterByMarketType(market, marketTypes);
    }
}
//# sourceMappingURL=FilterManager.js.map